import { FormikProps } from "formik";

import { useNavigationGuard } from "@/common/hooks/routing/useNavigationGuard";

import { RouteNavigationGuard } from "../../Routing/RouteNavigationGuard";

export interface BaseEntityCreateUpdateGuardsProps {
  formikProps: FormikProps<any> | undefined;
  isNavigationGuardEnabled?: boolean;
}

export function BaseEntityCreateUpdateGuards({
  formikProps,
  isNavigationGuardEnabled = true,
}: BaseEntityCreateUpdateGuardsProps) {
  const navigationGuardCondition =
    isNavigationGuardEnabled && formikProps?.dirty && !formikProps?.isSubmitting;

  // confirm navigation if form is dirty.
  useNavigationGuard({
    condition: navigationGuardCondition,
  });

  return (
    <>
      {/* Confirm navigation if form is dirty. */}
      <RouteNavigationGuard condition={navigationGuardCondition} />
    </>
  );
}
